import React, { useState, Fragment } from "react"
import { useSelector } from "react-redux"
import clsx from "clsx"

import FoodComboCardHeader from "./FoodComboCardHeader"
import { isNewComboInPreviousOrder, thousandSeparator } from "utils"
import { ComboModal, BuyXFreeXModal } from "components"
import classes from "./index.module.scss"

const FoodComboCard = props => {
  const { orderCombo, orderComboIndex, foodsMap } = props

  const combo =
    useSelector(state =>
      state.combos.find(combo =>
        combo.code === orderCombo.code
      )
    )

  const [openModal, setOpenModal] = useState(false)

  const isNew =
    isNewComboInPreviousOrder(orderCombo)

  return (
    <Fragment>
      <div className={classes["container"]}>
        <FoodComboCardHeader
          orderComboIndex={orderComboIndex}
        />
        <div
          className={classes["wrapper"]}
          onClick={() => setOpenModal(true)}
        >
          <div className={classes["names"]}>
            <div
              className={clsx(
                classes["name"],
                isNew && classes["new"]
              )}
            >
              {orderCombo.name}
            </div>
            <div className={classes["price"]}>
              {thousandSeparator(
                orderCombo.comboSetSalePrice
              )}
            </div>
          </div>
          {orderCombo.items.map((comboItem, ciIndex) =>
            <div
              key={ciIndex}
              className={classes["comboItem"]}
            >
              <div className={classes["left"]}>
                <div
                  className={clsx(
                    classes["comboItemName"],
                    isNew && classes["new"]
                  )}
                >
                  {comboItem.foodName}
                </div>
                {
                  !comboItem.isSimple &&
                  <div
                    className={clsx(
                      classes["comboItemOptionName"],
                      isNew && classes["new"]
                    )}
                  >
                    ({comboItem.optionName})
                  </div>
                }
              </div>
              <div
                className={clsx(
                  classes["quantity"],
                  isNew && classes["new"]
                )}
              >
                {comboItem.quantity}x
              </div>
            </div>
          )}
        </div>
      </div>
      {
        !!combo && combo?.isBuyxFreeX &&
        <BuyXFreeXModal
          combo={combo}
          foodsMap={foodsMap}
          openModal={openModal}
          setOpenModal={setOpenModal}
          orderComboIndex={orderComboIndex}
          initialValues={orderCombo.items}
        />
      }
      {
        !!combo && !combo?.isBuyxFreeX &&
        <ComboModal
          combo={combo}
          foodsMap={foodsMap}
          openModal={openModal}
          setOpenModal={setOpenModal}
          orderComboIndex={orderComboIndex}
          initialValues={orderCombo.items}
        />
      }
    </Fragment>
  )
}

export default React.memo(FoodComboCard)